// @flow

import React from 'react'
import { connect } from 'react-redux'
// $FlowFixMe
import { Route, Switch } from 'react-router-dom'

import Admin from 'src/containers/Admin'
import RoomDetail from 'src/components/RoomDetail'
import SecureRoom from 'src/containers/SecureRoom'
import ThankYou from 'src/containers/SecureRoom/components/ThankYou'
import Terms from 'src/containers/SecureRoom/components/Terms'
import Oops from 'src/containers/SecureRoom/components/Oops'

const ConnectedSwitch = connect(state => ({
  querystring: state.router.search
}))(Switch)

const Routes = () => {
  return (
    <ConnectedSwitch>
      <Route exact path="/admin" component={Admin} />
      <Route exact path="/:locationId/:roomId" component={RoomDetail} />
      <Route exact path="/:locationId/:roomId/secure" component={SecureRoom} />
      <Route exact path="/:locationId/:roomId/thanks" component={ThankYou} />
      <Route exact path="/thanks" component={ThankYou} />
      <Route exact path="/terms" component={Terms} />
      <Route exact path="/oops" component={Oops} />
    </ConnectedSwitch>
  )
}

export default Routes



// WEBPACK FOOTER //
// ./src/config/routes.js